import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { LoginFormComponent } from "./login-form/login-form.component";
import { LeftMenuComponent } from "./left-menu/left-menu.component";
import { NotificationComponent } from "./notification/notification.component";
import { OptionBarComponent } from "./option-bar/option-bar.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { PermissionDirective } from "@app/_directive/permission.directive";
import { BreadcrumbsComponent } from "./breadcrumbs/breadcrumbs.component";
import { ScheduleComponent } from "./schedule/schedule.component";
import { CertificationComponent } from "./certification/certification.component";
import { UiSwitchModule } from "ngx-ui-switch";
import { NgSelectModule } from "@ng-select/ng-select";
import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component";
import { SharedUtilService } from "./shared-util.service";
import { ResponseFormatterComponent } from "./response-formatter/response-formatter.component";
import { ResponseExtractorComponent } from "./response-extractor/response-extractor.component";
import { ScreenShotModalComponent } from "./screen-shot-modal/screen-shot-modal.component";
import { ResultsEndpointComponent } from "./results-endpoint/results-endpoint.component";
import { NgxJsonViewerModule } from "ngx-json-viewer";
import { LocatorPopOverComponent } from "./locator-pop-over/locator-pop-over.component";
import { SharedPipeModule } from "@app/_pipes/shared-pipe.module";
import { MultiValidationModalComponent } from "./results-endpoint/multi-validation-modal/multi-validation-modal.component";
import { DistributeLoadHelpModalComponent } from "./distribute-load-help-modal/distribute-load-help-modal.component";
import { EnvironmentMapModalComponent } from "./environment-map-modal/environment-map-modal.component";
import { SuiteResultComponent } from "./suite-result/suite-result.component";
import { LoadSizeHelpModalComponent } from "./load-size-help-modal/load-size-help-modal.component";
import { CronExpressionModalComponent } from "./schedule/cron-expression-modal/cron-expression-modal.component";
import { JiraConfigComponent } from "./jira-config/jira-config.component";
import { OpenValueModalComponent } from "./open-value-modal/open-value-modal.component";
import { SearchComponent } from "./endpoint-search/search.component";
import { ScheduleFormComponent } from './schedule/schedule-form/schedule-form.component';
import { MatTableModule } from "@angular/material/table";
import { DefaultThreadGroupComponent } from "./thread-group-modal/default-thread-group/default-thread-group.component";
import { UltimateThreadGroupComponent } from "./thread-group-modal/ultimate-thread-group/ultimate-thread-group.component";
import { ArrivalThreadGroupComponent } from "./thread-group-modal/arrival-thread-group/arrival-thread-group.component";
import { MatButtonModule } from "@angular/material/button";
import { MatRippleModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { OpenThreadGroupComponent } from './thread-group-modal/open-thread-group/open-thread-group.component';
import { MobileResultDetailsModalComponent } from "./results-endpoint/mobile-result-details-modal/mobile-result-details-modal.component";
import { MobileResultComponent } from "./results-endpoint/mobile-result/mobile-result.component";
import { ConfirmSaveDialogComponent } from "./confirm-save-dialog/confirm-save-dialogcomponent";
import { MobileConfigurationDetailsModalComponent } from './mobile-configuration-details-modal/mobile-configuration-details-modal.component';
import { CommonImageModalComponent } from './common-image-modal/common-image-modal.component';
import { MobileComponentInputDialogComponent } from "./results-endpoint/mobile-result/mobile-component-input-dialog/mobile-component-input-dialog.component";
import { ExtractorInfoDialogComponent } from "./extractor-info-dialog/extractor-info-dialog.component";
import { ThreadGroupTypeDialogComponent } from "@app/testcase/loadtest-config/thread-group-type-dialog/thread-group-type-dialog.component";
import { MobileScreenShotModalComponent } from "./mobile-screen-shot-modal/mobile-screen-shot-modal.component";
import { TableInfoComponent } from './table-info/table-info.component';
import { ReusableTableComponent } from './reusable-table/reusable-table.component';
import { ReviewComponent } from './review/review.component';
import { SharedAssociatedDetailsComponent } from "./shared-associated-details/shared-associated-details.component";
import { HistoryModalComponent } from "./history-modal/history-modal.component";
import { JiraErrorModalComponent } from "./jira-error-modal/jira-error-modal.component";
import { EndpointEditModalComponent } from "./endpoint-edit-modal/endpoint-edit-modal.component";
import { NewWebflowComponent } from "./new-endpoint/new-webflow/new-webflow.component";
import { NewWebsubflowComponent } from "./new-endpoint/new-websubflow/new-websubflow.component";
import { NewMobileflowComponent } from "./new-endpoint/new-mobileflow/new-mobileflow.component";
import { NewEndpointflowComponent } from "./new-endpoint/new-endpointflow/new-endpointflow.component";
import { CodemirrorModule } from "@ctrl/ngx-codemirror";
import { TestsuiteAssociateComponent } from "@app/testsuite/testsuite-associate/testsuite-associate.component";
import { MastersuiteAssociateComponent } from "@app/mastersuite/mastersuite-associate/mastersuite-associate.component";
import { JsonComparisonComponent } from "./json-comparison/json-comparison.component";
import { ExecCompareDetailsPageComponent } from "@app/testcase/exec-compare/exec-compare-details-page/exec-compare-details-page.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { PlotlyService } from "./plotly-graph/plotly.service";
import { MobilePerformanceGraphComponent } from "./mobile-performance-graph/mobile-performance-graph.component";
import { PerformanceGraphModalComponent } from "./performance-graph-modal/performance-graph-modal.component";
import { NewResultsEndpointComponent } from "./new-results-endpoint/new-results-endpoint.component";
import { FunctionalAutomationOverviewComponent } from "./overview/functional-automation-overview/functional-automation-overview.component";
import { MobileAutomationOverviewComponent } from "./overview/mobile-automation-overview/mobile-automation-overview.component";
import { PerformanceLabOverviewComponent } from "./overview/performance-lab-overview/performance-lab-overview.component";
import { ChaosSimulatorOverviewComponent } from "./overview/chaos-simulator-overview/chaos-simulator-overview.component";
import { DesktopAutomationOverviewComponent } from "./overview/desktop-automation-overview/desktop-automation-overview.component";

@NgModule({
  declarations: [
    LoginFormComponent,
    LeftMenuComponent,
    NotificationComponent,
    OptionBarComponent,
    PermissionDirective,
    BreadcrumbsComponent,
    ScheduleComponent,
    CertificationComponent,
    ResponseFormatterComponent,
    ResponseExtractorComponent,
    ScreenShotModalComponent,
    ConfirmDialogComponent,
    DistributeLoadHelpModalComponent,
    ResultsEndpointComponent,
    ReusableTableComponent,
    LocatorPopOverComponent,
    MultiValidationModalComponent,
    EnvironmentMapModalComponent,
    SuiteResultComponent,
    LoadSizeHelpModalComponent,
    CronExpressionModalComponent,
    JiraConfigComponent,
    OpenValueModalComponent,
    SearchComponent,
    TableInfoComponent,
    ScheduleFormComponent,
    DefaultThreadGroupComponent,
    UltimateThreadGroupComponent,
    ArrivalThreadGroupComponent,
    OpenThreadGroupComponent,
    ThreadGroupTypeDialogComponent,
    MobileResultComponent,
    MobileResultDetailsModalComponent,
    ConfirmSaveDialogComponent,
    MobileConfigurationDetailsModalComponent,
    CommonImageModalComponent,
    MobileComponentInputDialogComponent,
    ExtractorInfoDialogComponent,
    MobileScreenShotModalComponent,
    TableInfoComponent,
    ReviewComponent,
    SharedAssociatedDetailsComponent,
    HistoryModalComponent,
    JiraErrorModalComponent,
    EndpointEditModalComponent,
    NewWebflowComponent,
    NewWebsubflowComponent,
    NewMobileflowComponent,
    NewEndpointflowComponent,
    TestsuiteAssociateComponent,
    MastersuiteAssociateComponent,
    JsonComparisonComponent,
    ExecCompareDetailsPageComponent,
    MobilePerformanceGraphComponent,
    PerformanceGraphModalComponent,
    NewResultsEndpointComponent,
    ChaosSimulatorOverviewComponent,
    DesktopAutomationOverviewComponent,
    FunctionalAutomationOverviewComponent,
    MobileAutomationOverviewComponent,
    PerformanceLabOverviewComponent
  ],
  entryComponents: [
    ScreenShotModalComponent,
    ConfirmDialogComponent,
    MultiValidationModalComponent,
    DistributeLoadHelpModalComponent,
    EnvironmentMapModalComponent,
    LoadSizeHelpModalComponent,
    CronExpressionModalComponent,
    OpenValueModalComponent,
    ScheduleFormComponent,
    DefaultThreadGroupComponent,
    UltimateThreadGroupComponent,
    ArrivalThreadGroupComponent,
    OpenThreadGroupComponent,
    ThreadGroupTypeDialogComponent,
    MobileResultDetailsModalComponent,
    ConfirmSaveDialogComponent,
    MobileComponentInputDialogComponent,
    ExtractorInfoDialogComponent,
    MobileScreenShotModalComponent,
    SharedAssociatedDetailsComponent,
    HistoryModalComponent,
    JiraErrorModalComponent,
    EndpointEditModalComponent,
    JsonComparisonComponent,
    ExecCompareDetailsPageComponent,
    PerformanceGraphModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    UiSwitchModule,
    NgSelectModule,
    NgxJsonViewerModule,
    SharedPipeModule,
    MatTableModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatRippleModule,
    CodemirrorModule,
    DragDropModule
  ],
  exports: [
    LoginFormComponent,
    LeftMenuComponent,
    NotificationComponent,
    ResponseFormatterComponent,
    ResponseExtractorComponent,
    ScreenShotModalComponent,
    ScheduleComponent,
    OptionBarComponent,
    CertificationComponent,
    ResultsEndpointComponent,
    ReusableTableComponent,
    PermissionDirective,
    BreadcrumbsComponent,
    LocatorPopOverComponent,
    SuiteResultComponent,
    SearchComponent,
    TableInfoComponent,
    ScheduleFormComponent,
    DefaultThreadGroupComponent,
    UltimateThreadGroupComponent,
    ArrivalThreadGroupComponent,
    OpenThreadGroupComponent,
    MobileResultComponent,
    ThreadGroupTypeDialogComponent,
    MobileResultDetailsModalComponent,
    ConfirmSaveDialogComponent,
    MobileConfigurationDetailsModalComponent,
    ReusableTableComponent,
    EndpointEditModalComponent,
    NewWebflowComponent,
    NewWebsubflowComponent,
    NewMobileflowComponent,
    NewEndpointflowComponent,
    JsonComparisonComponent,
    ExecCompareDetailsPageComponent,
    MobilePerformanceGraphComponent,
    PerformanceGraphModalComponent,
    NewResultsEndpointComponent,
    ChaosSimulatorOverviewComponent,
    DesktopAutomationOverviewComponent,
    FunctionalAutomationOverviewComponent,
    MobileAutomationOverviewComponent,
    PerformanceLabOverviewComponent
  ],
  providers: [SharedUtilService, PlotlyService],
})
export class SharedModule {}
